import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

const TokenKey = 'Totems-Token'
const UserKey = 'Totems-user'
const frameMenuKey = 'Totems-menu'
const RoleKey = 'Totems-role'
Vue.use(VueLocalStorage)

var Cookies = Vue.localStorage

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setUser(token) {
  return Cookies.set(UserKey, token)
}

export function getUser(token) {
  return Cookies.get(UserKey, token)
}

export function setRole(token) {
  return Cookies.set(RoleKey, token)
}

export function getRole(token) {
  return Cookies.get(RoleKey, token)
}

export function setMenu(token) {
  return Cookies.set(frameMenuKey, token)
}

export function getMenu(token) {
  return Cookies.get(frameMenuKey, token)
}

export function removeUser(token) {
  return Cookies.remove(UserKey)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeAll() {
  Cookies.remove(UserKey)
  Cookies.remove(TokenKey)
  Cookies.remove(frameMenuKey)
  return true
}
export function GetCookie(cookiename) {
  var cookieStr = document.cookie
  var cookieArry = cookieStr.split('; ')
  var cookievalue = ''
  for (let i = 0; i < cookieArry.length; i++) {
    var thiskey = cookieArry[i].split('=')
    if (thiskey[0] === cookiename) {
      cookievalue = unescape(thiskey[1])
      break
    }
  }
  return cookievalue
}

export function Setcookie(cookiename, value, time = 1) {
  var nowdate = new Date()
  nowdate.setDate(nowdate.getDate() + time)
  document.cookie = cookiename + '=' + escape(value) + ';expires=' + nowdate.toGMTString()
}

